import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogMessage } from './confirmation-dialog-message';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
  public title = 'Are You Sure?';
  public content = 'Are you sure you want to complete this action?';
  public yes = 'Yes';
  public no = 'No';

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogMessage,
  ) {}

  ngOnInit(): void {
    if (this.data?.title) {
      this.title = this.data.title;
    }

    if (this.data?.message) {
      this.content = this.data.message;
    }

    if (this.data?.yesText) {
      this.yes = this.data?.yesText;
    }

    if (this.data?.noText) {
      this.no = this.data?.noText;
    }
  }
}
